// extracted by mini-css-extract-plugin
export default {"orders":"_orders_orders__7MOo2","orders__heading":"_orders_orders__heading__JyBNe","orders__para":"_orders_orders__para__8Doqf"};